export enum PublicPageFieldSlugEnum {
  Email = 'email',
  Password = 'password',
  ConfirmPassword = 'confirm_password',
  PlainPassword = 'plainPassword',
  FirstName = 'firstName',
  LastName = 'lastName',
  Recaptcha = 'recaptcha',
  TwoFactorAuthCode = 'authCode',
}
